import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'next/navigation';
import { useClient } from './useClient';
import { owlClient } from '../../apiUtils/client';
import { QueryKey } from '../../types';

export function useCustomLink() {
  const { client } = useClient();
  const query = useSearchParams();
  const params = useParams();
  const customLinkSlug = query?.get('customLink');
  const agentId = params?.agentSlug;

  const {
    data: customLink,
    isLoading: customLinkLoading,
    isInitialLoading,
  } = useQuery(
    [QueryKey.CustomLink],
    () =>
      owlClient.agent.getCustomLinkDetails({
        args: {
          agentId: agentId as string,
          customLinkSlug: customLinkSlug as string,
        },
      }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      onError: console.log,
      enabled: !!customLinkSlug && !!agentId,
    },
  );

  const customLinkData = client?.data.customLink ?? customLink?.data;
  const referralCompanyInfoExists =
    !!customLinkData?.referralPartnerCompany ||
    !!customLinkData?.referralPartnerLogoUrl;

  const referralPartnerInfoExists =
    !!customLinkData?.referralPartnerName ||
    !!customLinkData?.referralPartnerLogoUrl;

  return {
    customLink: customLinkData,
    customLinkLoading: isInitialLoading ?? customLinkLoading,
    referralEnabled:
      (referralPartnerInfoExists && referralCompanyInfoExists) ||
      referralCompanyInfoExists,
  };
}
